module.exports = __webpack_public_path__ + "img/c7cc2d9111869439f5b9b0ea2b766901.4f02b386.png";